<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    enable-background="new 0 0 100 100"
    xml:space="preserve">
    <path
      d="M74,79.69c1.104,0,2-0.896,2-2V23.258c0-1.104-0.896-2-2-2s-2,0.896-2,2v23.861
      c-0.286-0.275-0.516-0.443-0.583-0.491c-0.029-0.02-0.058-0.039-0.087-0.058L34.984,23.744c-1.877-1.232-3.855-1.452-5.426-0.604
      C27.932,24.017,27,25.897,27,28.298V72.65c0,2.4,0.932,4.28,2.557,5.158c1.57,0.849,3.549,0.629,5.393-0.582l36.379-22.848
      c0.03-0.019,0.059-0.038,0.087-0.058c0.068-0.048,0.297-0.216,0.583-0.491v23.86C72,78.795,72.896,79.69,74,79.69z M69.137,51.033
      L32.79,73.86c-0.704,0.461-1.181,0.51-1.332,0.429C31.281,74.193,31,73.664,31,72.65V28.298c0-1.014,0.281-1.543,0.458-1.639
      c0.037-0.02,0.092-0.032,0.167-0.032c0.231,0,0.641,0.117,1.199,0.482l36.305,22.802c0.207,0.166,0.43,0.448,0.449,0.555  C69.558,50.591,69.327,50.881,69.137,51.033z" />
  </svg>
</template>
